const TagLine = () => {
    return (
      <>
      <div className="jdTags flex flex-row min-sm:gap-3 ml-2 mb-4 max-sm:flex-col font-assistant">
                    <div className="jdTag_immediate jdTag active mt-2 text-primary-blue">
                      <svg
                        className="h-4 w-4 inline-block mr-1 "
                        fill="dodgerblue"
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 512"
                      >
                        <defs>
                          <style>.cls-1{"fill:currentColor ;"}</style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M144,160a80,80,0,1,1,80-80A80,80,0,0,1,144,160Zm368,0a80,80,0,1,1,80-80A80,80,0,0,1,512,160ZM0,298.7A106.74,106.74,0,0,1,106.7,192h42.7a107.27,107.27,0,0,1,44.6,9.7,125.85,125.85,0,0,0-1.9,22.3,128,128,0,0,0,43.3,96H21.3A21.38,21.38,0,0,1,0,298.7ZM405.3,320h-.7a127.69,127.69,0,0,0,43.3-96,137,137,0,0,0-1.9-22.3,105.73,105.73,0,0,1,44.6-9.7h42.7A106.74,106.74,0,0,1,640,298.7,21.32,21.32,0,0,1,618.7,320ZM416,224a96,96,0,1,1-96-96A96,96,0,0,1,416,224ZM128,485.3A133.33,133.33,0,0,1,261.3,352H378.7A133.33,133.33,0,0,1,512,485.3,26.69,26.69,0,0,1,485.3,512H154.7A26.69,26.69,0,0,1,128,485.3Z"
                        />
                      </svg>
                      <strong className="text--blue">
                        Excellent growth opportunities
                      </strong>
                    </div>

                    <div className="jdTag_immediate jdTag active mt-2 text-primary-blue">
                      <svg
                        className="h-3 w-3 inline-block mr-1 "
                        fill="dodgerblue"
                        id="Layer_1"
                        data-name="Layer 1"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512.05 448.1"
                      >
                        <defs>
                          <style>.cls-1{"fill:currentColor;"}</style>
                        </defs>
                        <path
                          className="cls-1"
                          d="M256,448c141.4,0,256-93.1,256-208S397.4,32,256,32,0,125.1,0,240c0,45.1,17.7,86.8,47.7,120.9-1.9,24.5-11.4,46.3-21.4,62.9a180.38,180.38,0,0,1-15.2,21.6c-2.1,2.5-3.7,4.4-4.9,5.7-.6.6-1,1.1-1.3,1.4l-.3.3h0a15.83,15.83,0,0,0-3.4,17.4A16,16,0,0,0,16,480.1c28.7,0,57.6-8.9,81.6-19.3,22.9-10,42.4-21.9,54.3-30.6A306.18,306.18,0,0,0,256,448.1ZM128,272a32,32,0,1,1,32-32A32,32,0,0,1,128,272Zm128,0a32,32,0,1,1,32-32A32,32,0,0,1,256,272Zm160-32a32,32,0,1,1-32-32A32,32,0,0,1,416,240Z"
                          transform="translate(0.05 -32)"
                        />
                      </svg>
                      <strong className="text--blue">Great Environment</strong>
                    </div>
                  </div>
      </>
    );
  };
  export default TagLine;